'use client';

import { useRef } from 'react';

import { ShippingService } from '@/services/modules/ShippingService';

export function useShippingService() {
  const ref = useRef<ShippingService | null>(null);
  if (ref.current === null) {
    ref.current = new ShippingService();
  }
  return ref.current;
}
